<template>
    <div class="file-upload-container">
        <div v-if="inTable">
            <div v-if="fileList.length" :class="{ 'file-preview-container': limit > 1 }">
                <div v-for="file in fileList" :key="file.url" class="file-preview-item">
                    <div v-if="isImageFile(file)" class="file-preview-content">
                        <img :src="file.url" class="file-preview-image" />
                    </div>
                    <div v-else class="file-preview-content">
                        <i :class="getFileIconClass(file)" class="file-icon"></i>
                        <span class="file-name">{{ getFileName(file) }}</span>
                        <span class="file-extension">{{ getFileExtension(file) }}</span>
                    </div>
                    <div class="file-preview-actions">
                        <i v-if="isImageFile(file)" @click="handlePreview(file)" class="el-icon-view">预览</i>
                        <i v-else @click="downloadFile(file.url)" class="el-icon-download">下载</i>
                        <i v-show="showPlusAndDel" @click="handleRemove(file)" class="el-icon-delete">删除</i>
                    </div>
                </div>
            </div>
            <el-upload ref="upload" :action="action" :multiple="multiple" :limit="limit" :on-exceed="handleExceed"
                :on-preview="handlePreview" :file-list="fileList" :http-request="fnUploadRequest" :accept="accept"
                :show-file-list="false" :on-remove="handleRemove" class="custom-upload">
                <div v-if="uploading" class="uploading-container">
                    <i class="el-icon-loading"></i>
                    <span>上传中...</span>
                </div>
                <i v-else class="el-icon-plus" v-show="showPlusAndDel">
                    <div slot="tip" class="el-upload__tip">限制{{ limit }}个文件</div>
                </i>
            </el-upload>
        </div>
        <!-- 非表格模式 -->
        <div v-else>
            <el-upload v-if="fileList.length < limit" ref="upload" :action="action" :multiple="multiple" :limit="limit"
                :on-exceed="handleExceed" :on-preview="handlePreview" :file-list="fileList"
                :http-request="fnUploadRequest" :list-type="listTypeMode" :accept="accept"
                :show-file-list="showFileList" :on-remove="handleRemove">
                <div v-if="uploading" class="uploading-container">
                    <i class="el-icon-loading"></i>
                    <span>上传中...</span>
                </div>
                <i v-else class="el-icon-plus" v-show="showPlusAndDel">
                    <div slot="tip" class="el-upload__tip">限制{{ limit }}个文件</div>
                </i>
            </el-upload>
            <div v-else class="file-preview-container" style="display: block;unicode-bidi: isolate;">
                <div v-for="file in fileList" :key="file.url" class="file-preview-item">
                    <div v-if="isImageFile(file)" class="file-preview-content">
                        <img :src="file.url" class="file-preview-image" />
                    </div>
                    <div v-else class="file-preview-content">
                        <i :class="getFileIconClass(file)" class="file-icon"></i>
                        <span class="file-name">{{ getFileName(file) }}</span>
                        <span class="file-extension">{{ getFileExtension(file) }}</span>
                    </div>
                    <div class="file-preview-actions">
                        <i v-if="isImageFile(file)" @click="handlePreview(file)" class="el-icon-view">预览</i>
                        <i v-else @click="downloadFile(file.url)" class="el-icon-download">下载</i>
                        <i v-show="showPlusAndDel" @click="handleRemove(file)" class="el-icon-delete">删除</i>
                    </div>
                </div>
            </div>
        </div>
        <!-- 图片预览对话框 -->
        <el-dialog width="60%" append-to-body :visible.sync="dialogVisible" :title="previewTitle">
            <img v-if="dialogFileUrl && isImageFile({ url: dialogFileUrl })" width="100%" :src="dialogFileUrl" alt="" />
            <div v-else-if="dialogFileUrl" class="file-not-preview">
                <i :class="getFileIconClass({ url: dialogFileUrl })" class="file-icon-large"></i>
                <p>该文件类型不支持预览，请下载后查看</p>
                <el-button type="primary" @click="downloadFile(dialogFileUrl)">下载文件</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
import { getAliyunPublicToken } from "@/api/oss/aliyun";
import oss from "ali-oss";
// import md5 from "js-md5";

export default {
    name: "FileUpload",
    props: {
        inTable: {
            type: Boolean,
            default: false,
        },
        showPlusAndDel: {
            type: Boolean,
            default: true,
        },
        action: {
            type: String,
            default: '#',
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        limit: {
            type: Number,
            default: 1,
        },
        showFileList: {
            type: Boolean,
            default: true,
        },
        uploadedFiles: {
            type: [Array, String],
            default: () => [],
        },
        listTypeMode: {
            type: String,
            default: '',
        },
        accept: {
            type: String,
            default: '.jpg,.jpeg,.png,.gif',
        },
        // 是否使用模拟上传
        useMockUpload: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        return {
            fileList: [],
            dialogFileUrl: "",
            dialogVisible: false,
            previewTitle: "",
            localUploadedFiles: [], // 本地上传的文件列表
            uploading: false // 添加上传状态变量
        };
    },
    watch: {
        uploadedFiles: {
            immediate: true,
            handler() {
                this.initializeFileList();
            }
        }
    },
    mounted() {
        this.initializeFileList();
    },
    created() {
        this.initializeFileList();
    },
    methods: {
        // 判断是否为图片文件
        isImageFile(file) {
            const imageExtensions = ['.jpg', '.jpeg', '.png', '.gif', '.bmp', '.svg', '.webp'];
            const extension = this.getFileExtension(file).toLowerCase();
            return imageExtensions.includes('.' + extension);
        },

        // 下载文件
        downloadFile(fileUrl) {
            const link = document.createElement('a');
            link.href = fileUrl;
            link.download = fileUrl.split('/').pop().split('?')[0];
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
        },

        // 初始化文件列表
        initializeFileList() {
            let files = [];
            if (typeof this.uploadedFiles === 'string' && this.uploadedFiles.length > 0) {
                try {
                    // 尝试解析为JSON
                    files = JSON.parse(this.uploadedFiles);
                } catch (e) {
                    // 如果不是JSON，则按逗号分割
                    files = this.uploadedFiles.split(',').map(url => url.trim()).filter(url => url).map(url => ({ url }));
                }
            } else if (Array.isArray(this.uploadedFiles)) {
                files = this.uploadedFiles.map(file => typeof file === 'object' ? file : { url: file });
            }

            // 确保每个文件对象都有必要的属性
            this.fileList = files.map(file => {
                // 提取文件名（包含后缀）
                let name = file.name;
                if (!name) {
                    // 从URL中提取文件名
                    const urlParts = file.url.split('/');
                    name = urlParts[urlParts.length - 1];
                    // 移除可能的查询参数
                    name = name.split('?')[0];
                }

                return {
                    ...file,
                    name: name,
                    url: file.url,
                    // 确保文件类型存在
                    fileType: file.fileType || this.getFileTypeFromName(name)
                };
            });

            this.localUploadedFiles = [...this.fileList];
        },

        // 获取文件后缀
        getFileExtension(file) {
            const name = file.fileName || file.name || file.url.split('/').pop().split('?')[0];
            const lastDotIndex = name.lastIndexOf('.');
            return lastDotIndex > -1 ? name.substring(lastDotIndex + 1).toUpperCase() : '';
        },

        // 获取文件名（不包含后缀）
        getFileName(file) {
            const name = file.fileName || file.name || file.url.split('/').pop().split('?')[0];
            const lastDotIndex = name.lastIndexOf('.');
            return lastDotIndex > -1 ? name.substring(0, lastDotIndex) : name;
        },

        // 根据文件类型获取图标类名
        getFileIconClass(file) {
            const extension = this.getFileExtension(file).toLowerCase();
            const iconMap = {
                'pdf': 'el-icon-document',
                'doc': 'el-icon-document',
                'docx': 'el-icon-document',
                'xls': 'el-icon-document',
                'xlsx': 'el-icon-document',
                'ppt': 'el-icon-document',
                'pptx': 'el-icon-document',
                'txt': 'el-icon-document',
                'zip': 'el-icon-folder',
                'rar': 'el-icon-folder',
                '7z': 'el-icon-folder'
            };
            // 确保非图片文件始终返回一个有效的图标类名
            return iconMap[extension] || 'el-icon-document';
        },

        // 从文件名获取文件类型
        getFileTypeFromName(name) {
            const lastDotIndex = name.lastIndexOf('.');
            if (lastDotIndex > -1) {
                return name.substring(lastDotIndex + 1).toLowerCase();
            }
            return 'unknown';
        },
        handleRemove(file) {
            this.fileList = this.fileList.filter(item => item.url !== file.url);
            this.localUploadedFiles = [...this.fileList]; // 删除后更新本地上传文件列表
            this.$emit('uploaded', this.fileList);
        },

        handleExceed() {
            this.$message.warning(`当前限制选择 ${this.limit} 个文件`);
        },

        handlePreview(file) {
            this.dialogFileUrl = file.url;
            this.previewTitle = file.fileName || file.name;
            this.dialogVisible = true;
        },

        async fnUploadRequest(option) {
            try {
                // 添加上传开始的提示或处理
                this.uploading = true; // 设置上传状态为 true
                this.$emit('uploading', true); // 向父组件发送上传开始事件
                
                if (option.onStart) {
                    option.onStart(option.file);
                }
                // 实际OSS上传
                // 1. 获取OSS Token
                const res = await getAliyunPublicToken();
                if (!res || !res.data) {
                    throw new Error('获取OSS Token失败');
                }

                const data = JSON.parse(res.data);
                // 验证Token数据完整性
                if (!data || !data.accessKeyId || !data.accessKeySecret || !data.bucketName) {
                    throw new Error('OSS Token数据不完整');
                }

                // 2. 创建OSS客户端
                const client = new oss({
                    region: data.point,
                    endPoint: data.point,
                    accessKeyId: data.accessKeyId,
                    accessKeySecret: data.accessKeySecret,
                    Expiration: data.expiration,
                    bucket: data.bucketName,
                    stsToken: data.securityToken,
                });

                // 3. 准备文件信息 - 只使用时间戳加文件后缀
                const originalName = option.file.name;
                const fileExtension = originalName.lastIndexOf('.') > -1 ? originalName.substring(originalName.lastIndexOf('.')) : '';
                const storeAs = new Date().getTime() + fileExtension;

                // 4. 执行上传
                const results = await client.multipartUpload(storeAs, option.file, {});

                // 5. 安全地获取URL
                const url = results.res.requestUrls[0].split("?")[0];

                // 6. 处理成功结果
                // 使用onSuccess返回的数据
                option.onSuccess({ url }, option.file);

                // 直接更新fileList
                this.fileList.push({
                    fileName: originalName,
                    name: originalName, // 保留name属性以兼容组件内部逻辑
                    url: url,
                    fileType: this.getFileTypeFromName(originalName),
                    sort: this.localUploadedFiles.length + 1
                });

                console.log('this.fileList::: ', this.fileList);
                this.$emit('uploaded', this.fileList);
                this.$message.success('文件上传成功');
            } catch (error) {
                // 处理上传失败
                this.$message.error('文件上传失败: ' + error.message);
                if (option.onError) {
                    option.onError(error, option.file);
                }
            } finally {
                // 无论上传成功还是失败，都设置上传状态为 false
                this.uploading = false;
                this.$emit('uploading', false); // 向父组件发送上传结束事件
            }

        }
    },
};
</script>

<style scoped>
.file-upload-container {
    margin-bottom: 20px;
    width: 100%;
}
.custom-upload .el-upload__input {
    display: none;
}

.file-preview-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
}

.file-preview-item {
    position: relative;
    display: inline-block;
    margin: 10px;
    width: 100px;
    height: 120px;
    text-align: center;
}

.file-preview-content {
    width: 100px;
    height: 100px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    border: 1px solid #dcdfe6;
    border-radius: 4px;
    background-color: #f5f7fa;
    position: relative;
    overflow: hidden;
}

.file-preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: opacity 0.3s ease;
}

.file-preview-item:hover .file-preview-image {
    opacity: 0.7;
}

.file-preview-actions {
    position: absolute;
    top: 0;
    right: 0;
    display: flex;
    flex-direction: column;
    background: rgba(0, 0, 0, 0.5);
    color: #fff;
    border-radius: 4px;
    padding: 5px;
    gap: 5px;
    opacity: 0;
    transition: opacity 0.3s ease;
}

.file-preview-item:hover .file-preview-actions {
    opacity: 1;
}

.file-preview-actions .el-icon-view,
.file-preview-actions .el-icon-download,
.file-preview-actions .el-icon-delete {
    cursor: pointer;
    font-size: 16px;
    color: #e6a23c;
}

.file-icon {
    font-size: 40px;
    color: #409eff;
    /* 确保图标始终可见 */
    display: block;
}

.file-icon-large {
    font-size: 80px;
    color: #409eff;
    margin-bottom: 20px;
}

.file-name {
    display: block;
    margin-top: 5px;
    font-size: 12px;
    text-align: center;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 80px;
}

.file-extension {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(0, 0, 0, 0.6);
    color: #fff;
    padding: 2px;
    font-size: 12px;
}

.file-not-preview {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 40px;
}

.file-not-preview p {
    margin: 20px 0;
    color: #606266;
}

/* 上传中状态样式 */
.uploading-container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100px;
    height: 100px;
    border: 1px dashed #d9d9d9;
    border-radius: 4px;
    background-color: #fafafa;
    color: #1890ff;
    font-size: 14px;
    cursor: not-allowed;
    transition: all 0.3s ease;
}

.uploading-container .el-icon-loading {
    margin-right: 8px;
    font-size: 18px;
    animation: rotating 1s linear infinite;
}

@keyframes rotating {
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
}
</style>
